import React from 'react'
import { motion } from 'framer-motion'
import { RefreshCw, CheckCircle, User, Building2, Settings } from 'lucide-react'

const AuthLoadingScreen = () => {
  const loadingSteps = [
    { icon: CheckCircle, text: "Authentication successful", delay: 0 },
    { icon: User, text: "Loading user profile", delay: 0.5 },
    { icon: Building2, text: "Fetching company details", delay: 1 },
    { icon: Settings, text: "Setting up dashboard", delay: 1.5 }
  ]

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="max-w-md w-full mx-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-lg shadow-sm p-8 text-center"
        >
          {/* Logo/Brand */}
          <motion.div
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2 }}
            className="mb-8"
          >
            <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mx-auto mb-4">
              <RefreshCw className="h-8 w-8 text-white animate-spin" />
            </div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">Welcome to HealthyCoach</h2>
            <p className="text-slate-600">Setting up your personalized dashboard...</p>
          </motion.div>

          {/* Loading Steps */}
          <div className="space-y-4 mb-8">
            {loadingSteps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: step.delay }}
                className="flex items-center space-x-3 text-left"
              >
                <div className="flex-shrink-0">
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: step.delay + 0.2 }}
                    className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center"
                  >
                    <step.icon className="h-4 w-4 text-green-600" />
                  </motion.div>
                </div>
                <motion.span
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: step.delay + 0.3 }}
                  className="text-slate-700 font-medium"
                >
                  {step.text}
                </motion.span>
              </motion.div>
            ))}
          </div>

          {/* Progress Bar */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="w-full bg-slate-200 rounded-full h-2 mb-4"
          >
            <motion.div
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: 2, ease: "easeInOut" }}
              className="bg-blue-600 h-2 rounded-full"
            />
          </motion.div>

          {/* Loading Text */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
            className="text-sm text-slate-500"
          >
            This will only take a moment...
          </motion.p>
        </motion.div>
      </div>
    </div>
  )
}

export default AuthLoadingScreen